import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  padding: 6px 15px;
  width: fit-content;
  font-size: ${fontSize.xs};
  font-weight: 400;
  background-color: ${colors.backgroundSurfacePrimary};
`;
function ProductTag({ tagName }) {
  return <Wrapper>{tagName}</Wrapper>;
}

export default ProductTag;
 